// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3oIsJ","insightsList":"newBusinessInsightsMenu_insightsList__3PU9C","active":"newBusinessInsightsMenu_active__1BhMA"};